import {useState, useEffect} from "react";
import ViolaterImage from "./ViolaterImage";
import GoogleMap from 'google-map-react';
import {selectedState} from "../App";
import {useRecoilState} from "recoil";

export default function RightPanel (props) {

    let [selectedData,setSelectedData] = useRecoilState(selectedState)
    console.log(selectedData)

    const [defaultProps,setDefaultProps] = useState({
        center: [selectedData.lat || 35.2828, selectedData.lng || -120.6596],
        zoom: 16
    });

    useEffect(() => {
      setDefaultProps({...defaultProps, center: [selectedData.lat || 35.2828, selectedData.lng || -120.6596]})
    }, [selectedData]);

    return  (
        <div className="relative h-screen">
            <GoogleMap
                // apiKey={YOUR_GOOGLE_MAP_API_KEY} // set if you need stats etc ...
                bootstrapURLKeys={{ key:"AIzaSyDCEkOeR1ChjRKEYRICA2SVaNFx28uSiqc"}}
                center={defaultProps.center}
                zoom={defaultProps.zoom}>
                {selectedData.selected ? <MyGreatPlace lat={selectedData.lat || 35.2828} lng={selectedData.lng ||-120.6596} text={'Here'}/>: <div/>}
            </GoogleMap>
            {
              selectedData.selected ?
            <div className="absolute top-0 left-0 flex flex-col p-4 bg-dark rounded-lg m-4 shadow-inner w-1/3">
              <div className="flex flex-row">
              <div className="font-bold font-gilroy text-white text-28">{selectedData.name}</div>
              <div className="flex-grow"></div>
              <div className="font-bold font-gilroy text-white text-28">{selectedData.time}</div>
            </div>
              <div className="font-gilroy text-white text-20">{selectedData.violation}</div>
              <div className="pt-2"><ViolaterImage imagePath={selectedData.imagepath}/></div>
            </div> : <div />
            }
        </div>
    )
}

function MyGreatPlace(props) {

    return (
            <div className={"rounded-full bg-red-300 h-4 w-4 "} />
    )


}
